import showSwalAlert from 'src/util/alerts'
import axios from 'axios'
import moment from 'moment'
import { DatePicker, Upload } from "element-ui";

const mixinUpload = {
    components: {
        [Upload.name]: Upload,
        [DatePicker.name]: DatePicker,
    },
    data () {
        return {
            model: {
                name: null,
                description: null,
                date: null,
                demand_id: null,
            },
            modelValidations: {
                name: {
                    required: true,
                },
                date: {
                    required: true,
                },
                annexes: {
                    required: true,
                },
            },
            annexes: [],
        }
    },
    methods:{
        validateForm(routeApi, routeWeb, nameStorage) {
            this.$validator.validateAll().then((isValid) => {
              if (isValid) this.submitUpload(routeApi, routeWeb, nameStorage);
            });
        },

        handlePreview(file) {
            this.$emit('cotentLoading', true)
            if (file.status == 'success') {
                axios({
                    url: file.url,
                    method: "GET",
                    responseType: "blob",
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", file.name);
                    document.body.appendChild(link);
                    link.click();
                    this.$emit('cotentLoading', false)
                });
            } else {
                const url = window.URL.createObjectURL(new Blob([file.raw]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", file.name);
                document.body.appendChild(link);
                link.click();
                this.$emit('cotentLoading', false)
            }
        },

        handleSuccess(file, nameStorage = '') {
            if (localStorage.getItem(nameStorage)) {
                this.annexes.forEach(annex => {
                    if (annex.name == file.raw.name) {
                        this.$refs.upload.handleRemove(file)
                        showSwalAlert('El archivo ' + file.raw.name + ' ya esta cargado en la lista de archivos.', 'warning')
                        return false
                    }
                })
            }

            const filesRaw = this.$refs.upload.uploadFiles.map(annexe => annexe.raw)
            let size = filesRaw.length - 1
            for (let index = 0; index < size; index++) {
                const element = filesRaw[index]
                if (element && element.name == file.raw.name.trim()) {
                    this.$refs.upload.handleRemove(element)
                    showSwalAlert('El archivo ' + file.raw.name + ' ya esta cargado en la lista de archivos.', 'warning')
                    return false
                }
            }

            let types = [
                'image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/zip',
                'multipart/x-zip',
                'application/x-zip-compressed',
                'application/x-rar-compressed',
                'application/octet-stream'
            ]

            if (!file.name.includes('.rar') && !types.includes(file.raw.type)) {
                showSwalAlert('Lo sentimos, ha seleccionado un archivo no valido, la extensión debe ser .pdf / .excel / .word / .jpg / .png / .zip / .rar!', 'warning');
                this.$refs.upload.handleRemove(file)
                return false
            }

            return true
        },

        submitUpload(routeApi, routeWeb, nameStorage = '') {
            this.$emit('cotentLoading', true)
            const filesRaw = this.$refs.upload.uploadFiles.map((file) => file.raw)
            const bodyFormData = new FormData();
            let urlHttp;

            if (!localStorage.getItem(nameStorage)) {
                filesRaw.forEach((file) => bodyFormData.append("annexes[]", file, file.name))
                urlHttp = 'https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/'+routeApi
            } else {
                let uids = this.annexes.map((file) => file.uid)
                filesRaw.forEach((file) => {
                    if (file) {
                        if (!uids.includes(file.uid)) {
                            bodyFormData.append("new_annexes[]", file, file.name)
                        }
                    }
                })

                let new_uids = this.$refs.upload.uploadFiles.map((file) => file.uid)

                this.annexes.forEach((annex) => {
                    if (!new_uids.includes(annex.uid)){
                        bodyFormData.append("blurry_annexes[]", annex.name)
                    }
                })

                urlHttp = 'https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/'+routeApi+'/'+this.model.id
            }

            bodyFormData.append("name", this.model.name);
            bodyFormData.append("description", this.model.description);

            if (nameStorage == 'demandEdit') {
                bodyFormData.append('code', this.model.demandform.code)
                bodyFormData.append('start_date', moment(String(this.model.rangeDate[0])).format('YYYY-MM-DD'))
                bodyFormData.append('finish_date', moment(String(this.model.rangeDate[1])).format('YYYY-MM-DD'))
            } else {
                bodyFormData.append("demand_id", this.model.demand_id);
                bodyFormData.append("date", moment(String(this.model.date)).format("YYYY-MM-DD"));
            }

            let self = this;

            axios({
                method: "post",
                url: urlHttp,
                data: bodyFormData,
                headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + this.$store.state.auth.token,
                },
            })
            .then(function (response) {
                self.$emit('cotentLoading', false)
                showSwalAlert(response.data.message, "success", false).then(() => self.$router.push(routeWeb));
            }).catch((error) => {
              self.$emit('cotentLoading', false)
              self.showMessageErrors(error)
            });
        },
    }
}

export default mixinUpload
